var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('h1',[_vm._v("AppButtonFlapViewer")]),_c('h2',[_vm._v("With Badge")]),_c('div',{staticClass:"wrapper"},[_c('AppButtonFlap',{attrs:{"icon":_vm.demoIcon,"with-badge":""}})],1),_c('h2',[_vm._v("Without Badge")]),_c('div',{staticClass:"wrapper"},[_c('AppButtonFlap',{attrs:{"icon":_vm.demoIcon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }